export default __webpack_public_path__ + "static/media/Frame 6.7ef78599.svg";